import { PlusSmallIcon } from "@heroicons/react/24/solid";
import { FormattedMessage } from "react-intl";
import Button from "../../ui-components/Button";

export const CreateTaskButton = ({ onClick, full=false }) => {
  return (
    <Button
      full={full}
      color="primary"
      className="mt-1"
      textCls="text-sm"
      onClick={onClick}
      paddingCls="py-2 px-8"
    >
      <PlusSmallIcon className="-ml-0.5 h-4 w-4" aria-hidden="true" />
      <FormattedMessage id="create_worksite_task" />
    </Button>
  )
};

export default CreateTaskButton;
